module.exports = __webpack_public_path__ + "static/media/baterias.553f21a0.png";